import {client} from '@core/GraphQLProvider';
import {
    GetCustomer,
    AddPayment,
    GetSelectedPaymentOption,
    SetSelectedPaymentOption,
    SubmitUserFeedback
} from './query.graphql';
import {addPaymentUpdateStrategy} from './mutations';

const CustomerService = {
    async getCustomer ( withOptions ) {
        const resp = await client.query( {
            query: GetCustomer,
            variables: {
                ...withOptions
            }
        } );

        return resp.data.customer;
    },

    async addPayment ( input ) {
        const resp = await client.mutate( {
            input,
            mutation: AddPayment,
            update: addPaymentUpdateStrategy
        } );

        return resp.data.addPayment;
    },

    getSelectedPaymentOption () {
        return client.query( {
            fetchPolicy: 'cache-only',
            query: GetSelectedPaymentOption
        } );
    },

    setSelectedPaymentOption ( input ) {
        return client.mutate( {
            mutation: SetSelectedPaymentOption,
            variables: {input}
        } );
    },

    submitUserFeedback ( {emailAddress, comments} ) {
        return client.mutate( {
            mutation: SubmitUserFeedback,
            variables: {
                input: {emailAddress, comments}
            }
        } );
    }
};

export default CustomerService;
